export function GetUserViewModel(user) {
  return {
    id: user.id,
    email: user.email,
    roles: user.roles.join(" "),
  };
}
